import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#58A1D5",
      "clip-path": "url(#clip0_2670_24862)"
    }, [
      _createElementVNode("path", { d: "M0 22.96C0 23.545.398 24 .86 24H23.13c.473 0 .871-.455.871-1.04 0-.571-.398-1.04-.871-1.04H.86c-.463 0-.861.469-.861 1.04M18.492 18.62c0 .728.377 1.157 1 1.157h2.486c.613 0 1-.429 1-1.157v-8.589c0-.727-.387-1.17-1-1.17h-2.485c-.624 0-1 .443-1 1.17zM12.662 18.62c0 .728.387 1.157 1 1.157h2.485c.624 0 1.011-.429 1.011-1.156V4.119c0-.727-.387-1.156-1.011-1.156h-2.485c-.613 0-1 .429-1 1.156zM6.842 18.62c0 .728.376 1.157.99 1.157h2.495c.613 0 1-.429 1-1.157V1.157c0-.727-.387-1.156-1-1.156H7.831c-.613 0-.99.429-.99 1.156zM1.011 18.62c0 .728.388 1.157 1 1.157h2.486c.624 0 1.01-.429 1.01-1.156V7.12c0-.715-.386-1.157-1.01-1.157H2.012c-.613 0-1 .442-1 1.157z" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_2670_24862" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }